import PropTypes from 'prop-types';

import './Trigger.scss';

const SearchTrigger = ({
  className,
  children,
  toggle = {
    className: 'rm-SearchToggle',
    'data-symbol': '⌘',
  },
  toggleSearch,
}) => (
  <div className={className}>
    <button aria-label={`Search ${toggle['data-symbol']}k`} {...toggle} onClick={toggleSearch}>
      {children || 'Search'}
    </button>
  </div>
);

SearchTrigger.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  toggle: PropTypes.shape({
    className: PropTypes.string,
    'data-symbol': PropTypes.string,
  }),
  toggleSearch: PropTypes.func,
};

export default SearchTrigger;
